import React from 'react'
import styled from '@emotion/styled'
import moment from 'moment'
import { Link } from '@reach/router'
import { colors } from 'style/theme'
import { Checkbox } from 'antd'
import TimeAgo from 'react-timeago'
import { toLocalTime } from 'utils/formatters'

const StyledCol = styled.span({
  fontWeight: 700,
  fontSize: 14
})

const StyledDate = styled(StyledCol)({
  color: colors.brandTextLight
})

const StyledLink = styled(Link)({
  fontWeight: 700,
  fontSize: '0.8rem'
})

function AccountsListColumns({ handleEnableAccount }) {
  return [
    {
      title: 'ACCOUNT NAME',
      dataIndex: 'name',
      key: 'name',
      width: '35%',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render(name) {
        return <StyledCol>{name}</StyledCol>
      }
    },
    {
      title: 'ACCOUNT TYPE',
      dataIndex: 'account_type',
      key: 'account_type',
      width: '20%',
      sorter: (a, b) => a.account_type.localeCompare(b.account_type),
      render(account_type) {
        return <StyledCol>{account_type}</StyledCol>
      }
    },
    {
      title: 'CREATED',
      key: 'create_date',
      width: '15%',
      dataIndex: 'create_date',
      sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
      render(create_date) {
        return (
          <StyledDate>
            <TimeAgo date={toLocalTime(create_date)} />
          </StyledDate>
        )
      }
    },
    {
      title: 'ENABLED',
      key: 'enabled',
      dataIndex: 'enabled',
      width: '15%',
      align: 'center',
      sorter: (a, b) => a.enabled.localeCompare(b.enabled),
      render(enabled, record) {
        return <Checkbox checked={enabled} onChange={() => handleEnableAccount(record.id)} />
      }
    },
    {
      dataIndex: 'id',
      width: '15%',
      render(id, record) {
        return record.enabled && <StyledLink to={`domains/${record.name}/${id}`}>VIEW ACCOUNT</StyledLink>
      }
    }
  ]
}

export default AccountsListColumns
